<template>
    <div>
        <login-box title="Agent Toolbar Login" :loading="loading" @login="doLogin" :error="error" />
    </div>
</template>
<script>
import LoginBox from "./components/LoginBox";

import {getAuthService} from "./auth-service";
export default {
	components: {LoginBox},
	data: () => ({loading: false, error: null}),
	async mounted() {
		this.authService = await getAuthService();
	},
	methods: {
		async doLogin(form) {
			this.loading = true;
			const authService = this.authService;
			console.info({authService});
			try {
				this.loading = true;
				const loginResult = await authService.loginToolbar(form.username, form.password);
				this.loading = false;
				if (loginResult.valid) {
					document.location = "#/empty";
					return;
				}

				this.error = "invalid username or password";
			}
			catch (e) {
				this.loading = false;
				this.error = "server error";
			}
		}
	}
};
</script>
